import {useEffect} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {LOOK_INTRO_STEPS} from "../../core/constants";
import {getCurrentLayout} from "../../../appLayout";

const LookIntroCanvasHighlighting = (props) => {

  const {imageCanvas, introStep, isMobile} = props;
  let timeoutId = null;

  const runHighlighting = async () => {

    const timeForEachLayer = 750;
    const layout = getCurrentLayout();
    const partIdsToHighLight = isMobile
      ? ["left_wall", "bathroom_floor", "front_wall"]
      : ["left_wall", "bathroom_floor", "right_wall"];

    let featureGroups = [];
    partIdsToHighLight.forEach(partId => {
      const featureGroup = layout.getFeatureGroupByPartId(partId);
      if (featureGroup && featureGroup.activeFeature) {
        featureGroups.push(featureGroup);
      }
    })

    const callRecursiveRendering = async () => {
      for (const featureGroup of featureGroups) {
        const zIndex = featureGroup.activeFeatureParts && featureGroup.activeFeatureParts.length && featureGroup.activeFeatureParts[0].layer.zIndex
          ? featureGroup.activeFeatureParts[0].layer.zIndex
          : featureGroup.activeFeature.layer.zIndex;
        imageCanvas.current.renderGreenLayerByZindex(zIndex, featureGroup.partId);
        await new Promise(resolve => timeoutId = setTimeout(resolve, timeForEachLayer));
      }
      timeoutId = setTimeout(callRecursiveRendering, 0); // auto call every added 1000 milliseconds
    };

    await callRecursiveRendering(); // first time
  }

  useEffect(() => {
    if (!imageCanvas || !imageCanvas.current) {
      return
    }
    if (introStep !== LOOK_INTRO_STEPS.wallsAndFloor) {
      clearTimeout(timeoutId);
      imageCanvas.current.draw(imageCanvas.current.state.layers);
      return;
    }
    runHighlighting();
    return () => {
      clearTimeout(timeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [introStep])

  return null
};

LookIntroCanvasHighlighting.propTypes = {
  imageCanvas: PropTypes.object
}

const mapStateToProps = (store) => {
  const {introStep, lookOverlayOpened} = store.lookState;
  const {canvasDimensions} = store.bathroomVisualizerState;
  const {windowWidth, windowHeight, isMobile} = store.serverState;
  return {
    lookOverlayOpened,
    introStep,
    canvasDimensions,
    windowWidth,
    windowHeight,
    isMobile,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookIntroCanvasHighlighting)
